import { render, staticRenderFns } from "./EditDish.vue?vue&type=template&id=16623a5e&lang=pug"
import script from "./EditDish.vue?vue&type=script&lang=js"
export * from "./EditDish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports